<template>
  <div>
     <section id="page-title">
        <div class="container clearfix">
          <h1 data-animate="fadeInUp">2016 SPRING</h1>
          <span data-delay="300" data-animate="fadeInUp">Snow White</span> 
        </div>
      </section>
      <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-1.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-1.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-2.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-2.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-3.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-springspring2016-3.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-4.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-4.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-5.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-5.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-6.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-6.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-7.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-7.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-8.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-8.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-9.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-9.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-10.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-10.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-11.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-11.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-12.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-12.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-13.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-13.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-14.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-14.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-15.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-15.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-16.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-16.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-17.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-17.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-18.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-18.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-19.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-19.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-20.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-20.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-21.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-21.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-22.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-22.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-23.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-23.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-24.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-24.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-25.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-25.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-26.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-26.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-27.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-27.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2016-spring/thumbs/spring2016-28.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2016-spring/spring2016-28.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>

                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
  </div>
</template>
<script>
  export default {
    name: "2016Spring",
    components: {
    },
    mounted(){
        jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        $('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
